import { useState, useEffect, useContext, useMemo } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE } from '@utils/CONST'
import API from '@api/api'
import { workflowOfSendTask } from '@utils/workflowOfBuildTaskV2';
import { useNavigate } from 'react-router-dom';

const PicModalRightButton = (props) => {
    const { item, isSelectPage, reEditClick, regenerateByTaskId, onCancel } = props
    const navigate = useNavigate()
    const [taskId, setTaskId] = useState()
    const [imageId, setImageId] = useState()
    const [imageUrl, setImageUrl] = useState()

    useEffect(() => {
        if (item) {
            setTaskId(item?.taskId.split('_')[0])
            setImageId(item?.results?.[0]?.id)
        }
    }, [item])

    useEffect(() => {
        const fetchImageUrl = async () => {
            if (!taskId || !imageId) return;
            try {
                let res = await API.batchCommonDownload({ taskId: taskId, imageId: imageId });
                if (res?.code != 0) throw new Error(res?.message);
                const image = res.data;
                setImageUrl(image)
            } catch (error) {
                console.error('Failed to fetch image:', error);
            }
        }
        fetchImageUrl();
    }, [taskId, imageId])

    const handleClick = async (jumpTotype, targetType = "inputImage") => {
        let noWaterRes = await API.batchCommonDownload({ taskId: taskId, imageId: imageId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data
        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, '_blank')
    }

    const resizeClick = () => {
        window.open(imageUrl ? `/home/imageResize?url=${encodeURIComponent(imageUrl)}` : `/home/imageResize`, '_blank')
    }

    const IsEiEdit = useMemo(() => {
        if (!item) return false
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])

    if (!item || IsEiEdit || item?.orgData) return null;

    const modifyImageGroup = [];
    const generateVideoGroup = [];
    const aiEditGroup = [];
    const reOperateGroup = [];

    // --- Visibility Logic based on PicModalFooter ---

    // Change Model
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH
    // popover: CHANGE_BKG_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换模特', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL) });
    }

    // Change Background
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH
    // popover: CHANGE_MODEL_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换背景', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.BACKGROUND) });
    }

    // Change Pose
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH || CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换姿势', icon: 'icon-poseFantasyOutlined', onClick: () => handleClick(IMAGE_TYPE.POSE_TRYON) });
    }

    // AI Tryon (Change Clothes)
    // showBtnList: (IMAGE_FINER_BATCH) || (CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH)
    if (item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '换衣服' : 'AI试衣', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL) });
    }

    // Change Shoes
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH || CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换鞋子', icon: 'icon-shoesOutlined', onClick: () => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES) });
    }

    // Change Glasses
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH || CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换眼镜', icon: 'icon-glassesOutlined', onClick: () => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON) });
    }

    // Sim Tryon
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH || CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '同版型试衣', icon: 'icon-sametryOutlined', onClick: () => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON) });
    }

    // Change Outfit (Fusion Wear)
    if (item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH && item.projectType !== BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '换穿搭', icon: 'icon-outfitSmallOutlined', onClick: () => handleClick(IMAGE_TYPE.FUSION_WEAR, RESOURCE_TYPE.FUSIONWEAR_MODEL) });
    }

    // Go to Grass
    if (item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        modifyImageGroup.push({ label: '去种草', icon: 'icon-sProductshowcaseOutlined', onClick: () => handleClick(IMAGE_TYPE.GRASS_PLANT) });
    }

    // Cloth Recolor
    if (item.projectType !== BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
        modifyImageGroup.push({ label: '服饰换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTH_RECOLOR) });
    }

    // Commodity Change Back
    // showBtnList: WATERMARK_REMOVE_BATCH || IMAGE_FINER_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH) {
        modifyImageGroup.push({ label: '商品换背', icon: 'icon-commidityOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITY) });
    }

    // Commodity Recolor
    // showBtnList: (TRYON_BATCH || IMAGE_FINER_BATCH) || (CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH) || (WATERMARK_REMOVE_BATCH)
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        modifyImageGroup.push({ label: '商品换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITYRECOLOR) });
    }


    // --- Generate Video Group ---

    // Image to Video
    // popover: Always
    generateVideoGroup.push({ label: '图生视频', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.IMAGE_TO_VIDEO) });

    // Motion Mimic
    // showBtnList: TRYON_BATCH || IMAGE_FINER_BATCH || CHANGE_MODEL_BATCH || CHANGE_BKG_BATCH || SIM_RECOLOR_BATCH
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        generateVideoGroup.push({ label: '动作模仿', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL_VIDEO) });
    }


    // --- AI Edit Group ---

    // Matting
    aiEditGroup.push({ label: '抠图', icon: 'icon-mattingOutlined', onClick: extractionClick });

    // Resize
    aiEditGroup.push({ label: '改尺寸', icon: 'icon-picResizeOutlined', onClick: resizeClick });

    aiEditGroup.push({ label: '修光影', icon: 'icon-lightIconOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'filllight', picUrl: imageUrl } }) });

    // Hand Repair
    aiEditGroup.push({ label: '修手', icon: 'icon-handRepairOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: imageUrl } }) });

    // Magic Erase
    aiEditGroup.push({ label: '去杂物', icon: 'icon-magicRemoveOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: imageUrl } }) });

    // Watermark Remove
    // popover: != WATERMARK_REMOVE_BATCH
    if (item.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        aiEditGroup.push({ label: '去水印', icon: 'icon-removeWatermark', onClick: () => handleClick(IMAGE_TYPE.WATERMARK_REMOVE) });
    }


    // --- Re-operate Group ---

    // Re-edit
    // footer: !isSelectPage && (!= IMAGE_FINER_BATCH && != SMART_DETAIL_PAGE_BATCH && != WATERMARK_REMOVE_BATCH)
    if (!isSelectPage &&
        item?.projectType != BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH &&
        item?.projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH &&
        item?.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        reOperateGroup.push({
            label: '重新编辑',
            icon: 'icon-rebuildOutlined',
            onClick: () => reEditClick(item?.projectId, item?.skuId, item?.taskId)
        });
    }

    // Regenerate
    // footer: !isSelectPage && (!= COMMODITY_STACKING_BATCH && != SMART_DETAIL_PAGE_BATCH)
    if (!isSelectPage &&
        item?.projectType != BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH &&
        item?.projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
        reOperateGroup.push({
            label: '再次生成',
            icon: 'icon-generateOutlined',
            onClick: () => { regenerateByTaskId(item?.taskId); onCancel() }
        });
    }

    return (
        <div className={`${styles.PicModalRightButton} _beauty_scrollbar`}>
            {modifyImageGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>修改图片</div>
                    {modifyImageGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {generateVideoGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>生成视频</div>
                    {generateVideoGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {aiEditGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>AI 编辑</div>
                    {aiEditGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}

            {reOperateGroup.length > 0 && (
                <div className={styles.group}>
                    <div className={styles.groupTitle}>再次操作</div>
                    {reOperateGroup.map((btn, idx) => (
                        <div key={idx} className={styles.btn} onClick={btn.onClick}>
                            <Iconfont type={btn.icon} className={styles.Icon} />
                            {btn.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default PicModalRightButton